import escape from 'lodash/escape';
import customfn from "@/_functions.js";
import clp from "@/_clp.js";

$(function () {
    // Edit the attached to
    $(document).on('click', '.detach-item', function(ev){
        ev.preventDefault();

        // Change the text
        $(this).hide();

        // Show the cancel nutton
        $(this).closest('.sub-grid-buttons').find('button.detach-cancel-editing').show();


        // Hide the status column and show the action column
        $(this).closest('div').next().find('.status-column').hide();
        $(this).closest('div').next().find('.actions-column').show();

    });

    // Undo editing for detachment
    $(document).on('click', '.detach-cancel-editing', function(ev){
        ev.preventDefault();
        $(this).hide();

        // Hide the status column and show the action column
        $(this).closest('div').next().find('.status-column').show();
        $(this).closest('div').next().find('.actions-column').hide();

        // Save button
        var save = $(this).closest('.sub-grid-buttons').find('a.btn');
        save.show();

        // remove the detach icon
        var attachedTo = $(this).closest('div').next();

        // Redo the status check
        clp.refreshHardware(attachedTo.find('table'));
    });

    // Detach the item.
    $(document).on('click', '.detach-hardware', function(ev){
        ev.preventDefault();
        var type = $(this).data('item-type');
        var form = $(this).closest('form');
        var url = $(this).attr('href');

        // Set the spinner
        //form.

        $.ajax(url, {
            method: "POST",
            cache: false,
            data: form.serialize(),
            success : function(data){
                if(data.status && data.status == 1){
                    // Slowly fade the row
                    form.closest('tr').hide("slow", function(){
                        if($(this).next().find('td').hasClass('error-row')){
                            $(this).next().remove();
                        }
                        $(this).remove();
                    })
                }
            }
        });
    })

    /**
     * Edit items - End
     */


    $(document).on('change, keyup', '.repeater-detail input[type="text"], .repeater-detail select, .iq-detail input[type="text"]', function(){
        var row = $(this).closest('form');

        if(row.find('input.old_data').length > 0) {
            var rowData = [];
            row.find('input[type="text"], select option:selected').each(function (i, el) {
                rowData.push($(el).val());
            });
            var newData = escape(JSON.stringify(rowData));

            if(newData != row.find('input.old_data').val() && newData != escape(row.find('input.old_data').val())) {
                // TODO check if input,select is enough and works
                row.find('tr input,select').removeClass('is-invalid').find('p.invalid-feedback').hide();
            }
        }
    });

    $(document).on('click', '.search-tags', function(ev){
        ev.preventDefault();

        let $clickedButton = $(this);
        let tagsoverview = $('.tag-overview');

        $clickedButton.next('.spinner').show();
        $clickedButton.hide();
        $('.validation-alert').remove();

        // Let's search for the tag
        let url = $clickedButton.attr('href');
        let formFields = $clickedButton.closest('form').serialize();
        tagsoverview.empty()

        $.ajax(url, {
            method: "POST",
            data: formFields,
            success : function(data){
                if(data.html){
                    tagsoverview.html(data.html);
                }
                $clickedButton.next('.spinner').hide();
                $clickedButton.show();
            },
            error :  function(data) {
                if(data.status === 422) {
                    let errors = data.responseJSON.errors;
                    for (let key in errors) {
                        let errorMessages = errors[key];
                        errorMessages.forEach(function(message) {
                            $('input[name="' + key + '"]').after('<div class="alert alert-danger validation-alert"><span>' + message + '</span></div>');
                        });
                    }
                    $clickedButton.next('.spinner').hide();
                    $clickedButton.show();
                }
            }
        });
    });

    $(document).on('click', '#replace-iq', function (ev) {
        ev.preventDefault();
        customfn.getModal($(this).data('href'), $(this), {}, function(){
            $('#iq_activation_code').click().focus();
        });
    })

    $(document).on('submit', '#centre_hardware_replace_iq', function (ev) {
        ev.preventDefault();
        var modal = $(this).closest('.modal');
        var url = $(this).attr('action');
        var formFields = $(this).serialize();
        formFields += '&iq_activation_code=' + $('#iq_activation_code').val();
        modal.find('.is-invalid').removeClass('is-invalid').find('p.invalid-feedback').val("").hide();
        $('.modal-body').find('.row.main_error').remove();
        customfn.postModal(url, formFields, {}, function(data){
            if(data) {
                var json = data.responseJSON || data;
                if (json.errors) {
                    for (var key in json.errors) {
                        const $input = modal.find('input[name="' + key + '"], select[name="' + key + '"]')
                        $input.addClass('is-invalid');
                        $input.closest('div.form-group').find('p.invalid-feedback').html(json.errors[key]).show();
                    }
                    modal.find('*[data-loading-text]').each(function() {
                        customfn.resetButtonLoadingState(this);
                    });
                    if(json.errors.main_error) {
                        $('.modal-body').append('<div class="row main_error"><div class="col-md-12"><div class="alert alert-danger alert-custom"><h4>'+json.errors.main_error+'</h4></div></div></div>');
                    }
                }
                if(json.redirect) {
                    window.location.href = json.redirect;
                }
            }
        });
    });

    $(document).on('click', '#restore-iq', function (ev) {
        ev.preventDefault();
        customfn.getModal($(this).data('href'), $(this), {keyboard: false, backdrop: 'static'});
    })

    $(document).on('click', '.unlink-locks-save', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        var formFields = $('form#unlink_locks_save_button').serialize();
        // hide the cancel button
        $('.delete-hardware .cancel-button').hide();

        customfn.postModal(url, formFields, {keyboard: false, backdrop: 'static'}, function(data) {

        });
    });

    $(document).on('click', '.commission-unlink-locks-save', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        var formFields = $('form#unlink_locks_save_button').serialize();

        // hide the cancel button
        $('.delete-hardware .cancel-button').hide();

        customfn.postModal(url, formFields,  {keyboard: false, backdrop: 'static'}, function(data){});
    });

    $(document).on('click', '.commission-unlink-locks-delete', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        var redirect = $(this).data('redirect');
        var formFields = $('form#unlock_locks_delete_button').serialize();

        customfn.postModal(url, formFields,  {keyboard: false, backdrop: 'static'}, function(data){
            if (redirect && !data.html) {
                window.location.href = redirect;
                return;
            }
            var lock_id = data.lock_id;
            var inventory_id = data.inventory_id;
            var toShow = data.toShow;
            var isDeleted = data.isDeleted;
            var clone = $('.clonediv[data-lock-id="'+lock_id+'"]');
            var rowIndex = clone.index();
            const errorButton = $('.error-button');
            if (clone) {
                if (errorButton.length) {
                    errorButton.remove();
                } else {
                    // reset mac address input
                    clone.find('input[type="text"]').val("").prop('readonly', false).removeAttr('readonly');
                    // reset standalone checkbox
                    clone.find('input[type=checkbox]').val('').prop({'disabled': false, 'checked': false});
                }
                clone.find('.detach-lock').attr('href',"");
                clone.find('.detach-lock').hide();

                var tr = clone.closest('tr');
                if(isDeleted) {
                    tr.hide();
                }

                // reset 'attach to' select
                tr.find('select[name="lock_attach_to[]"]').eq(rowIndex).attr('disabled', false).prop('disabled', false);

                var statusCol = tr.find('td[class*=_status]');
                statusCol.find('.spinner').hide();
                statusCol.find('.invalid-feedback').hide();
                statusCol.find('.btn').show();

                statusCol.prev().find('.clonediv:eq(' + rowIndex + ')').find('input[name="clp_lock_id[]"]').val('')
            }

            if(toShow !== undefined && toShow.length){
                // remove the grey from the multiple rooms
                if ($(document).find('#centre-centre-inventory-item-' + inventory_id).next().hasClass('clustered-with-row')) {
                    $(document).find('#centre-centre-inventory-item-' + inventory_id).next().hide();
                }
                $(document).find('#centre-centre-inventory-item-' + inventory_id).find('.multiple_rooms').removeClass('active').prop('disabled', true).attr('disabled', 'disabled');

                // loop over the toShow to show the
                $.each(toShow, function( index, value ) {
                    var row = $(document).find('#centre-centre-inventory-item-' + value.centre_inventory_id);
                    row.show();

                    // Remove all errors
                    row.find('input,select').removeClass('is-invalid');
                    row.find('p.invalid-feedback').html('').hide();

                    // Do not show the clustered button
                    row.find('button.multiple_rooms').addClass('disabled').removeClass('active').prop('disabled', true).attr('disabled', 'disabled');

                    // Remove all extra lock rows
                    row.find('td.lock-macs .clonediv:gt(0)').remove();
                    row.find('td.lock_device_select .clonediv:gt(0)').remove();
                    row.find('td.lock_status .clonediv:gt(0)').remove();

                    if (row.next().hasClass('clustered-with-row')) {
                        row.next().hide();
                    }
                });
            }

        });
    });

    $(document).on('click', '.unlink-repeaters-save', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        var formFields = $('form#unlink_repeater_save_button').serialize();

        // hide the cancel button
        $('.delete-hardware .cancel-button').hide();

        customfn.postModal(url, formFields);
    });

    $(document).on('click', '.unlink-iq-save', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        var formFields = $('form#unlink_iq_save_button').serialize();
        // hide the cancel button
        $('.delete-hardware .cancel-button').hide();

        customfn.postModal(url, formFields);
    });

    window.addEventListener('click', function(e) {
        const target = e.target.closest('.js-refresh-signal-strength');

        if (!target) {
           return;
        }
        e.preventDefault();

        if (target.disabled) {
            return;

        }

        target.disabled = true;
        const spinner = target.firstElementChild;
        spinner.classList.add('anim-spin');
        const nextElement = target.nextElementSibling;
        nextElement.innerHTML = '';
        axios.get('/lock-hardware/' + target.dataset.lockId + '/refresh_signal_strength')
            .then(function (response) {
               const html = customfn.getSignalStrengthIcon(response.data.signal_strength);
               const temp = document.createElement('div');
               temp.innerHTML = html;
               nextElement.replaceWith(temp.firstElementChild);
            })
            .catch(function (error) {
                if (error.response?.data?.unsupported) {
                    const msg = document.createElement('span');
                    msg.className = 'ms-2';
                    msg.textContent = 'Signal strength feature is not supported by IQ version';
                    nextElement.replaceWith(msg);
                    target.remove();
                }
            })
            .finally(() => {
                target.disabled = false;
                spinner.classList.remove('anim-spin');
            });
    });

    document.addEventListener('click', function(e) {
        if (!e.target.matches('.js-show-xs4-com-ids-for-lock')) {
          return;
        }
        e.preventDefault();
        const url = $(e.target).data('href');
        customfn.getModal(url, $(e.target));
    })

    document.addEventListener('click', async function (e) {
        const btn = e.target.closest('.js-copy-to-clipboard');
        if (!btn) {
            return;
        }

        e.preventDefault();
        const textToCopy = btn.previousElementSibling.value;
        const icon = btn.querySelector('i');
        await navigator.clipboard.writeText(textToCopy);
        icon.classList.replace('fa-copy', 'fa-check');
        icon.classList.add('text-success');
        setTimeout(() => {
            icon.classList.replace('fa-check', 'fa-copy');
            icon.classList.remove('text-success');
        }, 1500);
    })
});
